import { FC, useMemo, useCallback } from 'react';
import { useField, useFormikContext, FormikValues } from 'formik';
import { useTranslation } from 'react-i18next';
import HierarchyDropdownSingle from 'components/HierarchyDropdownSingle';

const HierarchyLocationField: FC<{ [x: string]: any }> = ({
  name,
  options,
  defaultExpanded = [],
  placeholder,
  onChange = () => {},
  ...rest
}) => {
  const { setFieldValue } = useFormikContext<FormikValues>();
  const [field, meta, helpers] = useField(name);

  const { t } = useTranslation();
  placeholder = placeholder || t('placeholder.typeToSearch');

  const handleChange = (value: string) => {
    setFieldValue(name, value, true);
    onChange(value);
    onClose(false);
  };

  const onClose = useCallback(
    (shouldValidate = true) => {
      if (!meta.touched) {
        helpers.setTouched(true, shouldValidate);
      }
    },
    [meta.touched, helpers]
  );

  const errorText = Boolean(meta.error && meta.touched) ? meta.error : '';
  const hasError = Boolean(meta.error && meta.touched);

  const rootItemId = useMemo(() => {
    const [firstNode] = options;

    return firstNode ? firstNode.value : null;
  }, [options]);

  return (
    <HierarchyDropdownSingle
      {...rest}
      name={name}
      placeholder={placeholder}
      value={field.value}
      options={options}
      onChange={handleChange}
      defaultExpanded={[...defaultExpanded, rootItemId]}
      error={hasError}
      helperText={errorText}
      onClose={onClose}
    />
  );
};

export default HierarchyLocationField;
